import { Injectable } from "@angular/core";
import { RoutingStates } from "../models/routingStates";

@Injectable({
  providedIn: "root",
})
export class RoutingStatesService {
  public routingStates: RoutingStates;

  setRoutingStates(routingStates: RoutingStates): void {
    this.routingStates = new RoutingStates(
      routingStates.urlNow,
      routingStates.urlNowId,
      routingStates.urlBefore,
      routingStates.urlBeforeId
    );
  }

  getRoutingStates(): RoutingStates {
    return this.routingStates;
  }

  removeRoutingStates(): void {
    this.routingStates = null;
  }
}
